import cookie from 'js-cookie';
import * as uuid from 'uuid';

import facebook from '~/services/facebook';
import facebookPixel from '~/services/facebook.pixel';

import type { User } from '../../types/User';
import UserEvent from './UserEvent';

type EventData = {
  clientIp: string | null;
  isBot: boolean;
  user: User;
};

class PageViewEvent extends UserEvent<EventData> {
  async sendToFacebook() {
    const eventId = uuid.v4();

    await facebookPixel.fireEvent({
      eventID: eventId,
      eventName: facebookPixel.StandardEventNames.PageView
    });

    const hashedProfile = await facebook.getHashedProfile(
      this.data.user.profile
    );

    const serverEventData = [
      {
        action_source: 'website',
        event_id: eventId,
        event_name: facebookPixel.StandardEventNames.PageView,
        event_time: Math.floor(Date.now() / 1000),
        user_data: {
          client_ip_address: this.data.clientIp,
          client_user_agent: navigator.userAgent,
          external_id: this.data.user.id ?? 'guest',
          fbc: cookie.get('_fbc'),
          fbp: cookie.get('_fbp'),
          ...hashedProfile
        }
      }
    ];

    this.serverEvents.push({ data: serverEventData, type: 'facebook' });
  }
}

export default PageViewEvent;
